<div *ngIf="showName === true || showName == null" [class.mat-subheading-1]="SmallDisplay" class="nobottommargin">
    {{ greeting }}, {{ username }}!<span fxHide.xs *ngIf="user?.CurrentRole"> ({{ user?.CurrentRole | roleText }} Access)</span>
</div>
